import { getLang } from "helpers/themeHelpers";

export const linkToSafetyTips = () => {
  const locale = getLang();
  return `/${locale}/${locale === "en" ? "safety-tips" : "قواعد-السلامة"}`;
};
